<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    
};
</script>
<style>
@import '../node_modules/vue-select/dist/vue-select.css';
</style>
